import Logotype from "./Logotype";
import { useAuth } from "hooks/auth";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CachedIcon from "@mui/icons-material/Cached";
import LogoutIcon from "@mui/icons-material/Logout";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useState, useEffect } from 'react';
import { useFilter } from "hooks/filter";
import { Tooltip } from "@mui/material";

export default function Topbar() {
  const { auth, setAuth } = useAuth();
  const [isPopUpButtonVisible, setPopUpButtonVisible] = useState(true);
  const { searchState } = useFilter();

  const logout = () => {
    setAuth({ isLoggedIn: false });
  };

  const openPopup = () => {
    const width = 600;
    const height = 700;

    // Get the active screen by checking the window placement API (for multi-screen setups)
    const screenX = window.screenX || window.screenLeft;
    const screenY = window.screenY || window.screenTop;
    // eslint-disable-next-line no-restricted-globals
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || screen.width;
    // eslint-disable-next-line no-restricted-globals
    const screenHeight = window.innerHeight || document.documentElement.clientHeight || screen.height;

    // Calculate the position of the pop-up window to be centered on the active screen
    const left = screenX + (screenWidth / 2) - (width / 2);
    const top = screenY + (screenHeight / 2) - (height / 2);

    //update local storage
    localStorage.setItem("SearchState", JSON.stringify(searchState));
    // Close the current popup window
    window.close();
    // Open the new popup window at the center

    chrome.windows.create({
      url: 'index.html?popup=true',
      type: 'popup',
      width: width,
      height: height,
      left: left,
      top: top
    }, (window) => {
      const windowId = window ? window.id : null;
      localStorage.setItem("PopUpWindowId", JSON.stringify(windowId));
    });
  };

  useEffect(() => {
    //use quesry string to hide pop up button
    const queryParams = new URLSearchParams(window.location.search);
    setPopUpButtonVisible(queryParams.get('popup')?.toLowerCase() !== 'true' && queryParams.get('sidebar')?.toLowerCase() !== 'true');
  }, []);

  return (
    <AppBar
      position="fixed"
      color="default"
      elevation={0}
      sx={{
        top: 'auto',
        bottom: 0,
        backgroundColor: '#ffffff',
        borderTop: '1.5px solid #009CDF',
      }}
    >
      <Toolbar variant="dense" sx={{ pl: 2, pr: 2 }} disableGutters>
        <Box sx={{ flexGrow: 1 }}>
          <Logotype />
        </Box>
        {auth.isLoggedIn && (
          <>
            {isPopUpButtonVisible && (
              <Tooltip title="Pop out to a new window">
              <IconButton
                size="small"
                edge="end"
                aria-label="open-as-popup"
                aria-controls="open-popup"
                aria-haspopup="true"
                onClick={openPopup}
                color="inherit"
              >
                <OpenInNewIcon />
                </IconButton>
              </Tooltip>)
            }
            <Tooltip title="Refresh">
            <IconButton
              size="small"
              edge="end"
              aria-label="reload"
              aria-controls="reload"
              aria-haspopup="true"
              onClick={() => window.location.reload()}
              color="inherit"
            >
              <CachedIcon />
            </IconButton>
            </Tooltip>
            <Tooltip title="Log out">
            <IconButton
              size="small"
              edge="end"
              aria-label="logout"
              aria-controls="logout"
              aria-haspopup="true"
              onClick={logout}
              color="inherit"
            >
              <LogoutIcon />
            </IconButton>
            </Tooltip>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}
